// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    getDealerRecommendationCount,
    getRegistrationResults,
    getTransferResults
} from '../../shared/repositories';
import actions from '../../actions-list';
import {buildDealerRecommendationCountPayload} from '../../dealer-recommendations/services/dealer-recommendation-helper';
import {buildRegistrationPayload} from '../../../product/shared/services/build-registration-payload';
import {buildTransferPayload} from '../../shared/services/build-transfer-payload';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';

export const updateTransferResultsWithFacets = isInitialLoad =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());
        const facets = getState().transferApprovals.facets;

        const facetsReg = getState().registrationReview.facets;

        const transferPayload = buildTransferPayload(facets, '', '');

        const registrationPayload = buildRegistrationPayload(facetsReg, '', '');

        try {

            const transferApprovals = await getTransferResults(transferPayload);

            dispatch({
                data: transferApprovals,
                type: actions.UPDATE_TRANSFER_RESULTS
            });

            if (isInitialLoad) {

                const registrationResults = await getRegistrationResults(registrationPayload);

                readExcelLayouts('registrations')(dispatch);

                dispatch({
                    data: registrationResults,
                    type: actions.UPDATE_REGISTRATION_RESULTS
                });

            }

            if (!getState().exportToExcel.selectedExcelLayout.transfers.name) {

                readExcelLayouts('transfers')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const updateDealerRecommendationCountWithFacets = selectedAccounts =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const dealerRecommendationPayload = buildDealerRecommendationCountPayload(selectedAccounts, 0, 50);

        try {

            const dealerRecommendations = await getDealerRecommendationCount(dealerRecommendationPayload, true);

            dispatch({
                data: dealerRecommendations,
                paginationType: 'requestedRecommendation',
                type: actions.GET_DEALER_RECOMMENDATIONS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetTransferResults = allowedDealers =>

    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.RESET_TRANSFER_APPROVAL_FACETS
        });

    };



// WEBPACK FOOTER //
// ./src/product/transfers/action-creators/facet-updates.js